// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"ae846eb4","98":"517e2be7","113":"3244f0b3","142":"4e708db5","438":"d4051fad","559":"8a4bafef","648":"fa795a34"}[chunkId] + ".chunk.js";
};